(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE={id:"12441.0.0"};


//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/node_modules/@sentry/webpack-plugin/src/sentry-webpack.module.js
// module id = 171
// module chunks = 73